/**
 * Experience Section for Assistant Profile
 * Handles experience level, years, employment type, and lead experience
 */
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { EXPERIENCE_LEVELS, EMPLOYMENT_TYPES } from "@/lib/profileOptions";

export default function ExperienceSection({
  experienceLevel,
  setExperienceLevel,
  yearsExperience,
  setYearsExperience,
  employmentType,
  setEmploymentType,
  hasBeenLead,
  setHasBeenLead
}) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">Experience Level</h2>
      
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {EXPERIENCE_LEVELS.map((level) => (
            <div 
              key={level.value}
              className={`p-4 bg-white/[0.05] border rounded-sm cursor-pointer transition-all text-center ${
                experienceLevel === level.value ? "border-white/40 bg-white/5" : "border-white/10"
              }`}
              onClick={() => setExperienceLevel(level.value)}
              data-testid={`experience-level-${level.value}`}
            >
              <div className="font-semibold mb-1">{level.label}</div>
              <div className="text-white/50 text-sm">{level.description}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Label className="text-sm text-white/60 uppercase tracking-wider">Years of Experience</Label>
            <Input
              type="number"
              value={yearsExperience}
              onChange={(e) => setYearsExperience(e.target.value)}
              min="0"
              max="50"
              className="mt-2 bg-white/[0.05] border-white/10 focus:border-white/40 text-white h-12 rounded-sm"
              data-testid="years-experience-input"
            />
          </div>
          <div>
            <Label className="text-sm text-white/60 uppercase tracking-wider">Employment Status</Label>
            <select 
              value={employmentType} 
              onChange={(e) => setEmploymentType(e.target.value)}
              className="mt-2 w-full h-12 bg-white/[0.05] border border-white/10 rounded-sm text-white px-3"
              data-testid="employment-type-select"
            >
              {EMPLOYMENT_TYPES.map((et) => (
                <option key={et.value} value={et.value}>{et.label}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex items-center justify-between p-4 bg-white/[0.05] border border-white/10 rounded-sm">
          <div>
            <div className="font-medium">Have you been a lead photographer?</div>
            <div className="text-white/50 text-sm">Primary shooter on jobs, not just assisting</div>
          </div>
          <Switch 
            checked={hasBeenLead} 
            onCheckedChange={setHasBeenLead} 
            data-testid="has-been-lead-switch"
          />
        </div>
      </div>
    </Card>
  );
}
